import { render, staticRenderFns } from "./shipAuditDetail.vue?vue&type=template&id=54ee3c3e&scoped=true"
import script from "./shipAuditDetail.vue?vue&type=script&lang=js"
export * from "./shipAuditDetail.vue?vue&type=script&lang=js"
import style0 from "./shipAuditDetail.vue?vue&type=style&index=0&id=54ee3c3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ee3c3e",
  null
  
)

export default component.exports